import styled from 'styled-components';

const EventsTemplateStyle = styled.section`
	--gap: var(--sp5x);

	margin-top: var(--pageDistance);

	.top-container {
		margin-top: var(--titleContentDistance);
	}

	.wrapper-events {
		display: flex;
		gap: var(--gap);
		flex-direction: column;
		margin-top: var(--titleContentDistance);
	}

	.left-block {
		.filter-inner-block {
			transform: scale(0);
			will-change: transform;
			transform-origin: left center;
			position: relative;
			z-index: 11;

			&.active {
				transition: transform 0.7s ease;

				transform: scale(1);
			}
		}
	}

	.tag-container {
		transform: scale(0);
		will-change: transform;
		transform-origin: left center;

		&.active {
			transition: transform 0.7s 0.3s ease;

			transform: scale(1);
		}
	}

	.right-block {
		.filter-inner-block {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			gap: var(--gutter);

			.tag-container {
				transform-origin: center;
			}
		}
	}

	.subscribe-wrapper {
		margin-top: var(--sectionDistance);
	}

	.pagination-wrapper {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;

		i {
			&.left-arrow {
				transform: rotate(90deg);
			}

			&.right-arrow {
				transform: rotate(-90deg);
			}
		}
	}

	/* //! FOR RENDERING */
	.subscribe-wrapper {
		display: none;

		&.active {
			display: block;
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--gap: var(--sp4x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--gap: var(--sp3x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--gap: var(--sp2-5x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--gap: var(--sp2-5x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--gap: var(--sp2-5x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--gap: var(--sp2x);

		.right-block {
			margin-top: var(--sp3x);

			.filter-inner-block {
				justify-content: flex-start;
			}
		}

		.wrapper-events {
			margin-top: var(--sp4x);
		}

		.filter-wrapper {
			display: flex;
			flex-direction: column;
			gap: var(--sp3x);

			.clear-all-block {
				width: fit-content;
				position: unset !important;
				top: unset !important;
				transform: unset !important;
				left: unset !important;
			}
		}
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--gap: var(--sp2x);

		.right-block {
			margin-top: var(--sp4x);

			.filter-inner-block {
				flex-wrap: wrap;
				align-items: flex-start;
			}
		}
	}
`;

export default EventsTemplateStyle;
